import React from 'react'

import { makeStyles } from '@material-ui/core/styles'

import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'

import settings from 'settings'

const {
  units,
} = settings

const useStyles = makeStyles(theme => ({
  unitCode: {
    paddingLeft: theme.spacing(),
    fontSize: '0.8em',
    color: '#999',
  }
}))

const UnitSelect = ({
  type,
  value,
  title,
  onChange,
  customUnits = [],
  className,
  error,
  touched,
}) => {
  const classes = useStyles()

  const baseUnits = units[type]

  if(!baseUnits) throw new Error(`unknown unit type: ${type}`)
  const useUnits = baseUnits.concat(customUnits)

  const selectElement = (
    <Select
      value={ value }
      onChange={ (e) => onChange(e.target.value) }
      className={ className }
      error={ touched && error ? true : false }
    >
      {
        useUnits.map((unit, i) => {
          return (
            <MenuItem 
              value={ unit.unit }
              key={ i }
            >
              <span>
                { unit.title }
              </span> 
              <span className={ classes.unitCode }>
                ({ unit.unit })
              </span>
            </MenuItem>
          )
        })
      }
    </Select>
  )

  return title ? (
    <FormControl component="fieldset">
      { title && <InputLabel>{ title }</InputLabel> }
      { selectElement }
    </FormControl>
  ) : selectElement
}

export default UnitSelect

